(function () {
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      const preorderBtn = form.querySelector('[data-preorder="true"]');
      if (!preorderBtn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const quickCheckoutModal = document.getElementById('quick-checkout-modal');
      if (quickCheckoutModal) quickCheckoutModal.style.display = 'none';
      const popup = document.getElementById('preorder-terms-popup');
      if (popup) popup.classList.add('active');
    },
    true
  );

  window.closePreorderPopup = function () {
    const popup = document.getElementById('preorder-terms-popup');
    if (popup) popup.classList.remove('active');
  };

  window.preorderAgree = function () {
    const popup = document.getElementById('preorder-terms-popup');
    if (popup) popup.classList.remove('active');

    const variantId = document.querySelector('.product-variant-id')?.value;
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(() => {
        window.location.href = '/cart';
      });
  };
})();